import { Link } from "react-router";
import { ArrowRightOutlined } from "@ant-design/icons";
import "../Footer/Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo">
            <img className="footer-logo-img" src="/imgs/logo.png" alt="PreNumbers" />
            <span className="footer-logo-text">PreNumbers</span>
          </div>
          <div className="footer-tagline">
            Investor-native FP&amp;A intelligence.
            <br />
            Industry-specific modeling, valuation,
            <br />
            and cap table — in one platform.
          </div>
          <Link to="/contact-sales" className="footer-demo-btn">
            Request a demo <ArrowRightOutlined />
          </Link>
        </div>

        <div className="footer-links-sections">
          <div className="footer-links-group">
            <div className="footer-links-title">Product</div>
            <Link to="/solutions">Solutions</Link>
            <Link to="/pricing">Pricing</Link>
            {/**             <Link to="/integrations">Integrations</Link>
            <Link to="/changelog">Changelog</Link>
            */}
          </div>
          <div className="footer-links-group">
            <div className="footer-links-title">Company</div>
            <Link to="/contact-sales">Contact</Link>

            {/* <Link to="/about">About</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/press">Press</Link> */}
          </div>
          {/* <div className="footer-links-group">
            <div className="footer-links-title">Legal</div>
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/terms-of-service">Terms</Link>
            <Link to="/security">Security</Link>
            <Link to="/dpa">DPA</Link>
          </div> */}
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-copy">© 2026 PreNumbers, Inc. All rights reserved.</div>
        <div className="footer-built">v3SG.84 · Used for Founders, CFOs, and Investors</div>
      </div>
    </footer>
  );
}

export default Footer;
